export default __webpack_public_path__ + "static/media/pelaporan.13e8c952.webp";